<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in" [innerHTML]="modalData.title"></h4>
</div>

<div class="modal-body">
    <div class="row" *ngIf="modalData.type === 'activities'">
        <div class="col-xs-12">
            <app-entity-activities [candidateId]="modalData.candidateInfo.id" [candidateName]="modalData.candidateInfo.name"
                [jobMatchId]="modalData.jobMatchId" [activityMap]="modalData.activityMap" context="candidate">
            </app-entity-activities>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'report'">
        <app-view-assessment-report [jobMatchId]="modalData.jobMatchId" [testInvitationId]="modalData.testInvitationId"
            [isSectionalReport]="modalData.isSectionalReport" [assessmentType]="modalData.assessmentType"
            [context]="modalData.context">
        </app-view-assessment-report>
    </div>

    <div class="row" *ngIf="modalData.type === 'imageProctoringInfo'">
        <div class="col-xs-12">
            <p style="margin-left:20px">Reason : <span>{{ modalData.activeViolation.reason }}</span></p>
            <div class="conversation-wrapper">
                <div class="conversation-content">
                    <div class="conversation-inner">
                        <div *ngFor="let info of modalData.techAssessmentReportInfoList" class="conversation-item item-right clearfix">
                            <div class="conversation-user">
                                <img src="assets/app-content/img/people/4dot5-default-no-profile-pic.jpg" alt="" class="notesAndCommunicationUserImage">
                            </div>
                            <div class="conversation-body">
                                <div class="name">
                                    <span>{{info.commentDto.user.firstName}} <span *ngIf="info.commentDto.user.lastName !== null">{{info.commentDto.user.lastName}}</span></span>
                                </div>
                                <div class="time d-none d-sm-block">
                                    <span>{{ info.commentDto.lastModifiedDate | date:'MMM dd, y hh:mm a' }}</span>
                                </div>
                                <div class="text">
                                    <b>{{info.type}}: </b><span>{{info.commentDto.comment}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'assessmentInfo'">
        <div class="col-xs-12">
            <app-assessment-info [jobMatchId]="modalData.jobMatchId" [assessmentType]="modalData.assessmentType"></app-assessment-info>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'meetings'">
        <div class="col-xs-12">
            <app-job-match-meetings [jobMatchId]="modalData.jobMatchId" [meetingType]="modalData.meetingType"
                (saveCallback)="saveCallback()"></app-job-match-meetings>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'setStatus'">
        <app-set-job-match-status [jobMatchDetailsArrayString]="modalData.jobMatchDetailsArray" [statusType]="modalData.statusType"
            (saveCallback)="saveCallback()" [multipleFlag]="false" sourceScreen="CANDIDATE_WORKFLOW"
            [formalizeActivityPayload]="modalData.formalizeActivityPayload">
        </app-set-job-match-status>
    </div>

    <div class="row" *ngIf="modalData.type === 'feedback'">
        <div class="modal-body" *ngIf="modalData.feedbackContext !== 'jobCandidatesCompare'">
            <app-job-match-profile-on-conference *ngIf="modalData.modalType === 'START_SCREENING'"
                [workflowStep]="modalData.workflowStep" [jobMatchId]="modalData.jobMatchId" [jobId]="modalData.jobId"
                [candidateId]="modalData.candidateId" [displaySchedules]="false" [displayCommunication]="true" context="conference"
                (completeFeedbackCallback)="saveCallback()" (saveCallback)="saveCallback()"
                sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-job-match-profile-on-conference>

            <app-feedback-execution *ngIf="modalData.modalType !== 'START_SCREENING'"
                [jobMatchId]="modalData.jobMatchId" [candidateId]="modalData.candidateId"
                (completeFeedbackCallback)="saveCallback()" (saveCallback)="saveCallback()"
                [feedbackType]="modalData.feedbackType" [externalCommentRequired]="false" [loginRequired]="true"
                sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-feedback-execution>
        </div>

        <div class="modal-body" *ngIf="modalData.feedbackContext === 'jobCandidatesCompare'">
            <app-feedback-execution [jobMatchId]="modalData.jobMatchId" [candidateId]="modalData.candidateId"
                (completeFeedbackCallback)="saveCallback()" (saveCallback)="saveCallback()"
                [feedbackType]="modalData.feedbackType" [externalCommentRequired]="false" [loginRequired]="true"
                sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-feedback-execution>
        </div>
    </div>

    <div class="px-4 mx-2 py-4" *ngIf="modalData.type === 'sendOutreachEmail'">
        <app-send-candidate-outreach-email
            [companyId]="modalData.companyId"
            [userId]="modalData.userId"
            [candidateId]="modalData.candidateId"
            [clientOrBuId]="modalData.clientOrBUId"
            context="candidateJobMatchCard"
            (closeCallback)="closeModal()"
            [isOutreachModal]="true"
            [jobMatches]="modalData.jobMatches"
            [candidateType]="modalData.candidateType"
            (successCallback)="saveCallback()"
            [salaryDurationOptions]="modalData.salaryDurationOptions"
            [jobTypeList]="modalData.jobTypeList">
        </app-send-candidate-outreach-email>
    </div>

    <div *ngIf="modalData.type === 'jobMatchAction'">
        <div class="row" *ngIf="modalData.subType === 'notes'">
            <app-notes-and-communication [jobMatchId]="modalData.jobMatchId" type="notes"
                (saveCallback)="refreshCallback()"
                [candidateInformationList]="modalData.candidateDetails?.candidateEmailSubjectAndBodyInformation?.candidateInfoInEmailBody">
            </app-notes-and-communication>
        </div>

        <div class="row" *ngIf="modalData.subType === 'communication'">
            <app-notes-and-communication *ngIf="modalData.communicationType === 'candidate'"
                [jobMatchId]="modalData.jobMatchId" type="communication" (saveCallback)="refreshCallback()"
                [candidateInformationList]="modalData.candidateDetails?.candidateEmailSubjectAndBodyInformation?.candidateInfoInEmailBody">
            </app-notes-and-communication>
            <app-user-communication *ngIf="modalData.communicationType === 'peer'"
                [candidateId]="modalData.candidateId" [jobId]="modalData.jobId" [jobMatchId]="modalData.jobMatchId"
                context="candidateJobMatchCard" (saveCallback)="refreshCallback()"
                [candidateInformationList]="modalData.candidateDetails?.candidateEmailSubjectAndBodyInformation?.candidateInfoInEmailBody">
            </app-user-communication>
        </div>

        <div class="row" *ngIf="modalData.subType === 'assignRecruiter'">
            <app-assign-recruiter [jobMatchIdArrayString]="jobMatchIdArrayJson" [recruiterId]="modalData.recruiterId"
                (saveCallback)="saveCallback()"></app-assign-recruiter>
        </div>

        <div class="row" *ngIf="modalData.subType === 'move'">
            <app-move-job-match-step [jobMatchId]="modalData.jobMatchId" [moveType]="modalData.moveType"
                (saveCallback)="saveCallback()" [label]="modalData.label" [candidateId]="modalData.candidateId"
                sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-move-job-match-step>
        </div>

        <div class="row" *ngIf="modalData.subType === 'sendAssessment'">
            <app-send-assessment [jobMatchId]="modalData.jobMatchId" [candidateId]="modalData.candidateId"
                [assessmentType]="modalData.assessmentType" [assessmentSendMode]="modalData.assessmentSendMode"
                [isSharedRequisition]="modalData.isSharedRequisition" [corporateId]="modalData.corporateCompanyId"
                [corporateName]="modalData.corporateCompanyName" [buName]="modalData.clientOrBUName" [notes]="modalData.notes"
                (saveCallback)="saveCallback()" sourceScreen="CANDIDATE_WORKFLOW"
                [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-send-assessment>
        </div>

        <div class="row" *ngIf="modalData.subType === 'cancelAssessment'">
            <app-cancel-assessment [jobMatchIdsArrayString]="modalData.jobMatchId + ''" [assessmentType]="modalData.assessmentType"
                (saveCallback)="saveCallback()" sourceScreen="CANDIDATE_WORKFLOW"
                [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-cancel-assessment>
        </div>

        <div class="row" *ngIf="modalData.subType === 'schedule'">
            <schedule-job-match-item [jobMatchObject]="modalData.candidateJobMatch" [jobLocation]="modalData.candidateJobMatch.jobLocation"
                [itemType]="modalData.scheduleType" [mode]="modalData.scheduleMode" [jobMatchId]="modalData.jobMatchId"
                (saveCallback)="saveCallback()" sourceScreen="CANDIDATE_WORKFLOW"
                [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </schedule-job-match-item>
        </div>

        <div class="row" *ngIf="modalData.subType === 'cancelMeeting'">
            <app-cancel-job-match-meeting [jobMatchObject]="modalData.candidateJobMatch" [itemType]="modalData.scheduleType"
                [isSharedRequisition]="modalData.isSharedRequisition" [jobMatchId]="modalData.jobMatchId"
                sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload"
                (saveCallback)="saveCallback(); closeModal()">
            </app-cancel-job-match-meeting>
        </div>

        <div class="row" *ngIf="modalData.subType === 'updateContact'">
            <app-add-edit-candidate-contact [candidateId]="modalData.candidateId"
                (saveCallback)="saveCallback()" (cancelCallback)="closeModal()">
            </app-add-edit-candidate-contact>
        </div>

        <div class="row" *ngIf="modalData.subType === 'actions'">
            <div class="col-xs-12" *ngIf="modalData.modalType === 'CANDIDATE_JOB_COMPARE'" style="max-height: 500px; overflow-y: scroll">
                <app-candidate-job-match-profile [jobMatchId]="modalData.jobMatchId" [jobId]="modalData.jobId"
                    [candidateId]="modalData.candidateId" [candidateType]="modalData.candidateDetails?.candidateType"
                    [candidateDetails]="modalData.candidateDetails" context="candidateJobComparison"
                    sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
                </app-candidate-job-match-profile>
            </div>
            <app-candidate-job-match-profile *ngIf="modalData.modalType === 'CANDIDATE_PROFILE'" style="max-height: 600px; overflow-y: scroll"
                [jobMatchId]="modalData.jobMatchId" [jobId]="modalData.jobId" [candidateId]="modalData.candidateId"
                [candidateType]="modalData.candidateDetails?.candidateType" context="candidateJobMatchCard"
                [candidateDetails]="modalData.candidateDetails" sourceScreen="CANDIDATE_WORKFLOW"
                [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-candidate-job-match-profile>
            <div class="col-xs-12" *ngIf="modalData.modalType === 'EXPORT_CANDIDATE_INFO'">
                <app-export-candidate-documents [jobMatchId]="modalData.jobMatchId" [jobMatchInfo]="modalData.jobMatchInfo"
                    [isCandidateExportInfo]="true" (cancelCallback)="closeModal()">
                </app-export-candidate-documents>
            </div>
            <div class="col-xs-12" *ngIf="modalData.modalType === 'CANDIDATE_BOOKLET'">
                <app-job-match-profile-on-conference [workflowStep]="modalData.workflowStep" [jobMatchId]="modalData.jobMatchId"
                    [jobId]="modalData.jobId" [candidateId]="modalData.candidateId" [displaySchedules]="false"
                    [displayFeedback]="true" [displayCommunication]="false" [displayPhoneScreenCompletedFeedbacks]="true"
                    context="conference" sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
                </app-job-match-profile-on-conference>
            </div>
            <div class="col-xs-12" *ngIf="modalData.modalType === 'SEND_EMAIL'">
                <app-email-documents context="candidateJobMatchCard" [document]="modalData.document" [documents]="modalData.documents"
                    [candidateDetails]="modalData.candidateDetails" (saveCallback)="closeModalAndRefresh()" (cancelCallback)="closeModal()"
                    sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
                </app-email-documents>
            </div>
            <div class="col-xs-12" *ngIf="modalData.modalType === 'CLIENT_REVIEW'">
                <app-email-client-review context="candidateJobMatchCard" [clientReviewDetails]="modalData.clientReviewDetails"
                    [jobMatchId]="modalData.jobMatchId" (saveCallback)="closeModalAndRefresh()" (cancelCallback)="closeModal()">
                </app-email-client-review>
            </div>
        </div>

        <div class="row" *ngIf="modalData.subType === 'uploadResume'">
            <div class="col-xs-12">
                <app-add-candidates [jobId]="modalData.jobId" [isSharedJob]="modalData.isSharedRequisition"
                    [corporateId]="modalData.corporateCompanyId" [clientOrBuId]="modalData.candidateJobMatch.clientOrBUId"
                    [onlyUploadResume]="true" [singleUploadResume]="true" [candidateId]="modalData.candidateJobMatch.id"
                    (saveCallback)="saveCallback()" sourceScreen="CANDIDATE_WORKFLOW"
                    [formalizeActivityPayload]="modalData.formalizeActivityPayload">
                </app-add-candidates>
            </div>
        </div>

        <div class="row" *ngIf="modalData.subType === 'screening'">
            <ng-container *ngIf="modalData.context !== 'jobCandidatesCompare'">
                <app-job-match-profile-on-conference *ngIf="modalData.modalType === 'START_SCREENING'"
                    [workflowStep]="modalData.workflowStep" [jobMatchId]="modalData.jobMatchId" [jobId]="modalData.jobId"
                    [candidateId]="modalData.candidateId" [displayCommunication]="true" context="conference"
                    (completeFeedbackCallback)="saveCallback()" (saveCallback)="refreshCallback()"
                    sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
                </app-job-match-profile-on-conference>
                <app-feedback-execution *ngIf="modalData.modalType !== 'START_SCREENING'"
                    [jobMatchId]="modalData.jobMatchId" [candidateId]="modalData.candidateId"
                    (completeFeedbackCallback)="saveCallback()" (saveCallback)="refreshCallback()"
                    [feedbackType]="modalData.feedbackType" [externalCommentRequired]="false" [loginRequired]="true"
                    sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
                </app-feedback-execution>
            </ng-container>
            <app-feedback-execution *ngIf="modalData.context === 'jobCandidatesCompare'"
                [jobMatchId]="modalData.jobMatchId" [candidateId]="modalData.candidateId"
                (completeFeedbackCallback)="saveCallback()" (saveCallback)="refreshCallback()"
                [feedbackType]="modalData.feedbackType" [externalCommentRequired]="false" [loginRequired]="true"
                sourceScreen="CANDIDATE_WORKFLOW" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-feedback-execution>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'confirmResendAssessment'">
        <div class="col-xs-12">
            <form role="form" name="resendAssessmentForm" novalidate>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="form-group">
                            <label class="control-label" *ngIf="!modalData.assessmentDetails.isSendAssessmentFailed">
                                Are you really sure you want to re-send the assessment to the candidate, as it will be another attempt ?
                                <br>The previous attempt was in '<span class="emerald">{{ modalData.assessmentDetails.assessmentLinkStatus }}</span>' state and it occurred at '<span class="emerald">{{ modalData.previousStateDateTime | fourDotFiveTimeStampFormatPipe }}</span>'
                            </label>
                            <label class="control-label" *ngIf="modalData.assessmentDetails.isSendAssessmentFailed">
                                Are you sure you want to re-send the assessment to the candidate?
                                <br>
                                <span *ngIf="modalData.previousStateDateTime !== null">The previous attempt was made on '<span class="emerald">{{ modalData.previousStateDateTime | fourDotFiveTimeStampFormatPipe }}</span>'</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="form-group">
                            <label for="reasonForResend" class="control-label">
                                Reason:
                            </label>
                            <select class="form-control" style="display:inline; width: 70%;" id="reasonForResend" name="reasonForResend" [(ngModel)]="resendReason" required>
                                <option value="Technical Issue with Assessment">Technical Issue with Assessment</option>
                                <option value="Validity Period for completed assessment has ended">Validity Period for completed assessment has ended</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="resendReason === 'Other'">
                    <div class="col-xs-12">
                        <div class="form-group">
                            <div class="mb-2">
                                <app-voice-input
                                    (transcriptReady)="onVoiceTranscript($event)"
                                    [candidate]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.candidate : null"
                                    [company]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.company : null"
                                    [requisition]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.requisition : null"
                                    [jobMatch]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.jobMatch : null"
                                    [sourceScreen]="'CANDIDATE_WORKFLOW'">
                                </app-voice-input>
                            </div>
                            <textarea id="otherReasonNotes" name="otherReasonNotes" class="form-control" rows="3" placeholder="Enter your reason.." [(ngModel)]="otherReasonNotes" required></textarea>
                            <app-formalize-comment
                                [inputText]="otherReasonNotes"
                                (outputText)="receiveFormalizedComment($event)"
                                [candidate]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.candidate : null"
                                [company]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.company : null"
                                [requisition]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.requisition : null"
                                [jobMatch]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.jobMatch : null"
                                [sourceScreen]="'CANDIDATE_WORKFLOW'">
                            </app-formalize-comment>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 text-right">
                        <div class="clearfix">
                            <button type="button" class="btn btn-success pull-right mr-2" style="margin-left: 5px" (click)="resendAction(true)">
                                <span>Yes</span>
                            </button>
                            <button type="button" class="btn btn-danger pull-right" (click)="resendAction(false)">
                                <span>No</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
